import { formatScorecardValue } from '@/features/scorecard/scorecard-table.utils'
import { formatDate } from '@/lib/format'
import type { ScorecardMetricDataType } from '@/services/scorecard.service'
import type { OgsmBoardNode, OgsmTargetType } from '@/types/api'

/** OGSM says PERCENT where the Scorecard formatter says PERCENTAGE. */
export function toScorecardDataType(
  type: OgsmTargetType
): ScorecardMetricDataType | undefined {
  if (type === 'CURRENCY') return 'CURRENCY'
  if (type === 'PERCENT') return 'PERCENTAGE'
  if (type === 'NUMBER') return 'NUMBER'
  return undefined
}

interface TargetFields {
  value: number | null | undefined
  text: string | null | undefined
  date: string | null | undefined
}

/** Display text for a target, or '' when there is nothing to show. */
export function formatTarget(
  node: Pick<OgsmBoardNode, 'targetType' | 'descriptor'>,
  { value, text, date }: TargetFields,
  withUnit: boolean
): string {
  if (node.targetType === 'TEXT') return text ?? ''
  if (node.targetType === 'DATE') return date ? formatDate(date) : ''
  if (value === null || value === undefined) return ''
  const formatted = formatScorecardValue(
    value,
    toScorecardDataType(node.targetType),
    withUnit && node.targetType === 'NUMBER' ? node.descriptor : null
  )
  const unit = node.descriptor?.trim()
  return withUnit && unit && node.targetType !== 'NUMBER'
    ? `${formatted} ${unit}`
    : formatted
}
